import TopSection from "../components/topSection";
import BG from "../assets/gallery_bg.JPG";
import "../styles/gallery.css";
import img1 from "../assets/hero.webp";
import img2 from "../assets/about.webp";
import img3 from "../assets/home_gallery1.jpg";
import img4 from "../assets/home_gallery2.jpg";
import img5 from "../assets/home_gallery3.jpg";
import img6 from "../assets/home_gallery4.jpg";
import img7 from "../assets/home_gallery5.JPG"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import ImageModal from "../components/ImageModal";

const images = [img1, img2, img3, img4, img5, img6, img7, img1, img2, img3, img4, img5];
function Gallery() {
  const columns = [[], [], [], []];

  images.forEach((img, i) => {
    columns[i % 4].push(img);
  });

const [modalImage, setModalImage] = useState(null);
  const [caption, setCaption] = useState('');

  const openModal = (src, text) => {
    setModalImage(src);
    setCaption(text);
  };

  const closeModal = () => {
    setModalImage(null);
    setCaption('');
  };

  return (
    <>
      <TopSection image={BG} text={"Gallery"}  backgroundPositionY={"0%"}  />
      <section className="light-bg py-5">
        <div className="container">
          <div className="row m-0 p-0">
            {columns.map((col, i) => (
              <div key={i} className="col-10 col-md-4 col-xl-3 mx-auto p-2">
                {col.map((img, j) => (
                 <div className="p-2 px-1">
                     <div key={j} className="gallery-item">
                    <img
                      key={j}
                      src={img}
                      alt={`gallery-${i}-${j}`}
                      className="gallery-img m-auto "
                    />
                    
                      <div className="hover-overlay" onClick={() => openModal(img, 'Photographs of Brief by Cristian UK')}>
                        <div className="hover-icon">
                          <FontAwesomeIcon icon={faCrosshairs} />
                        </div>
                        <p className="hover-caption">
                          Photographs of Brief by Cristian UK
                        </p>
                      </div>
                    
                  </div>
                 </div>
                ))}
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center align-items-center mt-5">
            <div style={{ height: "fit-content" }}>
              <button className="btn-bawa primary-dark-btn">see more</button>
            </div>
          </div>
        </div>
      </section>
      <ImageModal src={modalImage} caption={caption} onClose={closeModal} />
    </>
  );
}
export default Gallery;
